module.exports = __webpack_public_path__ + "files/955056d86c6d46fe8965e434e30160c8.svg";